import { Theme } from '.'

export default {
  banner: {
    src: '/bahasa/banner.jpg'
  }
} as Theme